(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("evr", [], factory);
	else if(typeof exports === 'object')
		exports["evr"] = factory();
	else
		root["evr"] = factory();
})(window, function() {
return 